export const getCurrencySymbol = (
    currency?:
        | 'USD'
        | 'KRW'
        | 'EUR'
        | 'AUD'
        | 'BRL'
        | 'CAD'
        | 'CNY'
        | 'GBP'
        | 'HKD'
        | 'IDR'
        | 'JPY'
        | 'MYR'
        | 'NZD'
        | 'PHP'
        | 'SGD'
        | 'TWD'
        | 'THB'
        | 'VND'
        | undefined
) => {
    switch (currency) {
        case 'EUR':
            return '€';
        case 'KRW':
            return '₩';
        case 'USD':
            return '$';
        default:
            return '$';
    }
};
